import React from "react";
import { useRef, useEffect, useState } from "react";
import Hari from "./Untitled-2.png";
import Png from "./pngwing.com.png";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import { useInView } from "react-intersection-observer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowDown } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@iconify/react";
import downloadLoop from "@iconify/icons-line-md/download-loop";
import styles from "./protfolioabout.module.css";
import { motion } from "framer-motion";
export function Proabout() {
  const { ref: myRef, inView: myElementIsVisible } = useInView();
  const { ref: magicSectionRef, inView: magicSectionIsVisible } = useInView();
  return (
    <div className={styles.protfololiobody} id="pabout">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 mt-5" ref={myRef}>
            <span className={styles.proaboutname}>
              <div className="mt-5" ref={magicSectionRef}>
                <span
                  className={`${styles.rocket} ${
                    magicSectionIsVisible ? styles.hari : ""
                  }`}
                >
                  <h4 className=" col-lg-12 text-light mb-1">Discover</h4>
                  <h3 className="text-light text-decoration-underline col-lg-12 ">
                    About ME
                  </h3>
                  <p className="text-light ml-3">
                    {" "}
                    As a highly passionate and dedicated Front-End Developer
                    based in Coimbatore, India, my objective is to utilize my
                    expertise in Front-End and Graphic design tools to build
                    premium and visually appealing websites. Additionally, my
                    skills in Marketing, Retail, and Hospitality sectors can be
                    leveraged to create innovative and effective digital
                    solutions for businesses in these industries. Ultimately, I
                    strive to create impactful and user-friendly websites that
                    drive business growth and success.
                  </p>
                  <button className={styles.proaboutbtn}>
                    <a
                      className="button"
                      href="https://drive.google.com/file/d/1fXVj89VsIHrLuJZBvUVc7lKdGqt1_1up/view?usp=share_link"
                      download
                      target="_blank"
                    >
                      DOWNLOAD CV
                      <Icon icon={downloadLoop} width="25" height="25" />
                    </a>
                  </button>
                </span>
              </div>
            </span>
          </div>
          <div className="col-lg-6 ">
            <span className={styles.proaboutphoto}>
              <span className={styles.prohari}>
                <img src={Hari} className="col-lg-7 mt-5" />
              </span>
              <span className={styles.propng}>
                <img src={Png} className="col-lg-8  mt-5" />
              </span>
            </span>
          </div>
        </div>
        {/* <div className='spacer layer'></div> */}
      </div>
    </div>
  );
}
